// import React, { Component } from "react";
// import Axios from "/plugins/axios";
// import ReactJWPlayer from 'react-jw-player';

// class VideoWidget extends Component {
//     constructor(props){
//         super(props);
//         this.state = {
//             title: '',
//             playerId: '',
//             videoUrl: '',
//             image: ''
//         }
//     }

//     render(){
//         const { title, playerId, videoUrl, image } = this.state;
//         return (
            // <div style={{width:'100%'}}>
            //     <div style=
            // {{position: 'relative',
            //                 width: '100%',
            //                 paddingTop: '56.25%',
            //                 backgroundColor: 'red'
            //     }}>
//                 <ReactJWPlayer
//                         playerId='V4qGuYBl'
//                         playerScript={`https://cdn.jwplayer.com/libraries/V4qGuYBl.js`}
//                         playlist={[{
//                             file: `${videoUrl}`,
//                             image: `${image}`,
//                         },
//                         ]}
//                         isAutoPlay
//                         width='100%'
//                         height='100%'
//                         style={{position: 'absolute', top: 0}}

//                     />
//             // </div>
//             // </div>
//         );
//     }
//     componentDidMount(){
//         Axios.get(`/videos/${this.props.url.query.id}`)
//         .then(res => {
//             this.setState({
//                 title: res.data.data.title,
//                 playerId: res.data.data.jwplayer_id,
//                 videoUrl: res.data.data.video_url,
//                 image: res.data.data.posters.thumb
//            })
//         })
//     }

// }

// export default VideoWidget;



import React,{useEffect,useState} from 'react';
import Axios from "/plugins/axios";
// import ReactJWPlayer from 'react-jw-player';
// import styleReset from "/static/css/styleReset.css";
import Head from 'next/head';
import TagManager from 'react-gtm-module';
import WidgetJwPlaylistPlayer from '/components/widgetJwPlaylistPlayer';
import ClapprPlayer from '/components/Clappr/ClapprPlayer';
import {isFacebookApp} from '/utils/common';

const tagManagerArgs = {
    // gtmId: 'GTM-WCJSTPT',
    dataLayer: {
      userId: '001',
      userProject: 'project',
      CRMAuthor: 'CRMAuthor',
      Section: 'Section',
      articlePublishedDate: 'articlePublishedDate',
  }
}

 const VideoWidget = (props) => {
    const [data, setData] = useState([]);
    const [load, setLoad] = useState(false);
    const [error, setError] = useState('');
    const targetOrigin = process.env.IS_LOCALHOST ? 'http://localhost' + (process.env.PORT ? ':'+process.env.PORT : '') : process.env.BACKEND_URL;
    const showAds = data.no_ads ? false : true;
    let customProps = null;
    // const url = props.url.query;
    const jwPlayerId =  props.url && props.url.query.playerId ? props.url.query.playerId : data.jwplayer_id;

     if(data){
         customProps = {
             ga: {
                 label: data && data.title ? data.title : 'No Title'
             }
         };
         if ( !data.no_ads ) {
             if ( data.ad_tag ) // set custom AdTag
                 customProps.advertising = {
                     client: "googima",
                     tag: data.ad_tag
                 };
         }
         else { //inject empty AdTag
             customProps.advertising = {
                 tag: ''
             };
         }
         customProps.floating = !data.ad_tag;
     }

    useEffect(() => {
        Axios.get(`/videos/${props.url.query.id}`)
            .then(res => {
                let video = res.data.data;
                setData(video);
                setLoad(true);
                window.parent.postMessage(res.data.data && res.data.data.length !== 0 ? 'isContent' : 'noContent', `${targetOrigin}`)

                tagManagerArgs.dataLayer.CRMAuthor = video.author ? video.author.name : 'Undefined';
                tagManagerArgs.dataLayer.Section = 'videos';
                tagManagerArgs.dataLayer.articlePublishedDate = video.published_date.date;
                if(video.campaign || isFacebookApp() ){
                    tagManagerArgs.dataLayer.utmCampaign = video.campaign ? video.campaign.utm_campaign : "duwun-video-widget";
                    tagManagerArgs.dataLayer.utmContent = video.campaign ? video.campaign.utm_content : 'Undefined';
                    tagManagerArgs.dataLayer.utmMedium = video.campaign ? video.campaign.utm_medium : 'social';
                    tagManagerArgs.dataLayer.utmSource = video.campaign ? video.campaign.utm_source : 'facebook';
                    tagManagerArgs.dataLayer.utmTerm = video.campaign ? video.campaign.utm_term : 'Undefined';
                }
                TagManager.dataLayer(tagManagerArgs)
            })
            .catch(err => {
                window.parent.postMessage('noContent', `${targetOrigin}`)
                setError(err.message);
                setLoad(true)
            })
    }, []);

    if (load) {
        if(error){
            return (
                <h3 style={{ textAlign: 'center' }}>{error}</h3>
            )
        }
        else if( data && data.length !== 0) {
            // const tvTypeIndex = data.categories && data.categories.findIndex((category) => category.type === 'TV')
            // const type = tvTypeIndex >= 0 ? 'tv' : 'videos'; // if type is not TV, go to videoDetail.
            const envPlayer = process.env.WIDGET_PAGE_PLAYER && process.env.WIDGET_PAGE_PLAYER.toLowerCase();
            let parentPath = props.url.query.postId ? (props.url.query.categories ? "/"+props.url.query.categories.replace(",", "/")+"/" : "/") + props.url.query.postId : "";

            return (
                    <React.Fragment>
                    <Head>
                        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
                        <link href="/static/css/widgetStyle.css" rel="stylesheet" />
                    </Head>
                    {   envPlayer === 'jwplayer' ?
                        <WidgetJwPlaylistPlayer
                            poster={data.posters.thumb}
                            source={data.video_url}
                            parentPath={parentPath}
                            currentItem={data}
                            data={data}
                            customProps={customProps}
                            jwPlayerId={jwPlayerId}
                            isVideoWidget
                        />
                        :
                        <ClapprPlayer
                            id="video-widget-clappr-player"
                            width="100%"
                            height="calc(100vw * 0.5625)"
                            autoPlay
                            poster={data.posters.thumb }
                            source={data.video_url}
                            video={data}
                            isWidget
                        />
                    }
                    {
                       showAds ? <div style={{ textAlign: 'center' }} id="video-ad-companion"></div> : null
                    }
                </React.Fragment>
            );
        }else{ return <h3>There is no video.</h3> };
    } else {
        return (
            <div>
                Loading video widget...
                <div className="placeholderbox">
                  <div className="banner-holder"></div>
                  <hr className="hr-box" />
                  <span className="title-holder text-group"></span>
                  <div className="text-group p-holder"></div>
                  <div className="text-group"></div>
                </div>
            </div>
        );
    }
};
export default VideoWidget;
